import { render, staticRenderFns } from "./ReportTable.ts.vue?vue&type=template&id=98c4d946"
import script from "./ReportTable.ts.vue?vue&type=script&lang=ts"
export * from "./ReportTable.ts.vue?vue&type=script&lang=ts"
import style0 from "./ReportTable.ts.vue?vue&type=style&index=0&id=98c4d946&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports